import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export const Legal = () => {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-technical-white py-16">
      <div className="max-w-7xl mx-auto container-padding">
        <h1 className="text-4xl font-heading text-abyssal-blue mb-8">
          {language === 'fr' ? 'Mentions légales' : 'Legal'}
        </h1>
        <div className="placeholder-box h-96">
          [[LEGAL PAGE - Coming Soon]]
        </div>
      </div>
    </div>
  );
};